/**
 * 模板市场-筛选条件动作定义
 * @author VenDream
 * @since 18/06/06
 */

import { get } from '@fe/common/lib/ajax';
import ACTIONS from 'constants/action.json5';
import { getOpenZoneFilterList, getOrgZoneFilterList } from 'api/store';
import { uniqueId } from 'utils/common';

// 推荐类型筛选项索引
const RECOMMEND_TYPE = 4;
// 玩法类型筛选项索引
const PLUGIN_TYPE = 13;
// 企业专区默认类别
const DEFAULT_FILTER = {
  groupId: 'DEFAULT_FILTER',
  groupName: '类别',
  tags: [
    { id: 1, name: '展示页' },
    { id: 2, name: '活动玩法' },
    { id: 15, name: '海报' },
  ],
};

const apis = {
  filters: '/api/store/template/filters',
};
//之前的接口数据转换
function transformFilterData(data) {
  if (!data) return [];
  let resArr = [[]];
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if (element.type === 'normal') {
      let children =
        element.tags &&
        element.tags.map(ele => {
          return { fieldKey: ele[0], name: ele[1] };
        });
      resArr[0].push({
        name: element.parentName,
        fieldKey: element.fieldName,
        type: 0,
        showType: 0,
        children,
      });
    }
  }
  return resArr;
}
//获取接口返回所有角标key/value
function getCornerLabel(arr) {
  if (!arr) return null;
  let resArr = arr.flat();
  let resObj = {};
  let targetArr = [];
  for (let index = 0; index < resArr.length; index++) {
    const element = resArr[index];
    if (element.type === 2) {
      //type为2是角标类型
      targetArr.push(...element.children);
    }
  }
  for (let i = 0; i < targetArr.length; i++) {
    const ele = targetArr[i];
    resObj[ele.fieldKey] = ele.name;
  }

  return resObj;
}
// 设置筛选条件
export function getStoreFilters(category) {
  return async dispatch => {
    try {
      const filters = await get(apis.filters, { category });
      if (filters) {
        if (
          category === 'ENTERPRISE' ||
          category === 'VIP' ||
          category === 'MY_TPL'
        ) {
          filters.list = transformFilterData(filters);
        }
        //前端排序，类别排在首位
        let sortArr = (filters.list && filters.list[0]) || [];
        let arrElement = undefined;
        let arrIndex = undefined;
        for (let index = 0; index < sortArr.length; index++) {
          const element = sortArr[index];
          if (element.type === 3) {
            arrElement = sortArr[index];
            arrIndex = index;
          }
        }
        if (arrElement) {
          sortArr.splice(arrIndex, 1);
          sortArr.unshift(arrElement);
          filters.list[0] = sortArr;
        }
        //老接口的数据需要转换成新接口一样的数据
        dispatch({
          type: ACTIONS.SET_STORE_FILTERS,
          payload: { category, filters: filters.list },
        });

        //角标改成后台可以配置的、需要保存到store
        let tplCornerLabelObj = getCornerLabel(filters.list);
        dispatch({
          type: ACTIONS.SET_STORE_CORNER_LABEL,
          payload: { tplCornerLabelObj },
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
}

// 获取企业专区筛选条件
export function getOrgZoneFilters(orgId) {
  return async dispatch => {
    try {
      const data = await getOrgZoneFilterList(orgId);
      const filters = formatOrgZoneFilters(data);
      dispatch({
        type: ACTIONS.SET_ORG_ZONE_FILTERS,
        filters,
      });
    } catch (e) {
      console.error(e);
    }
  };
}

// 保存企业专区查询条件
export function setOrgZoneSearchFilters(filters) {
  return dispatch => {
    dispatch({ type: ACTIONS.SET_ORG_ZONE_SEARCH_FILTERS, filters });
  };
}

// 格式化企业专区筛选条件
const formatOrgZoneFilters = data => {
  // 新增默认类别
  data.unshift(DEFAULT_FILTER);
  // 新增全部tag
  data.forEach(item => {
    const { tags } = item;
    Array.isArray(tags) &&
      tags.length > 0 &&
      tags.unshift({ id: 'ALL', name: '全部' });
  });
  return data;
};

// 获取开放平台筛选条件
export function getOpenZoneFilters() {
  return async dispatch => {
    try {
      const filters = await getOpenZoneFilterList();
      const openZoneFilters = formatOpenZoneFilters(filters);
      const firstTag = openZoneFilters.systemTags[0];
      const firstId = firstTag && firstTag.firstId;
      const openSearchFilters = {
        firstId,
        systemTags: [],
        customTagIds: [],
        mostHot: true,
      };
      dispatch({
        type: ACTIONS.SET_OPEN_ZONE_FILTERS,
        payload: { openZoneFilters, openSearchFilters },
      });
    } catch (e) {
      console.error(e);
    }
  };
}

// 保存平台专区查询条件
export function setOpenSearchFilters(filters) {
  return dispatch => {
    dispatch({
      type: ACTIONS.SET_OPEN_SEARCH_FILTERS,
      filters,
    });
  };
}

// 格式化平台专区filters
function formatOpenZoneFilters(data) {
  const { systemTags = [], customTags = [] } = data;
  // 推荐-筛选项name改为‘全部’,置于首位
  const recommendIndex = systemTags.findIndex(
    item => +item.firstId === RECOMMEND_TYPE
  );
  const recommendTag = systemTags[recommendIndex];
  recommendTag.name = '全部';
  if (recommendIndex !== -1) {
    systemTags.splice(recommendIndex, 1);
    systemTags.unshift(recommendTag);
  }
  // 玩法-名称替换为活动页
  const pluginTag = systemTags.filter(tag => +tag.firstId === PLUGIN_TYPE)[0];
  pluginTag && (pluginTag.name = '活动页');
  // 系统标签新增全部tag
  systemTags.forEach(firstFilter => {
    const { children } = firstFilter;
    Array.isArray(children) &&
      children.forEach(secondFilter => {
        const { children } = secondFilter;
        Array.isArray(children) &&
          children.length > 0 &&
          children.unshift({ name: '全部', fieldKey: 'ALL', id: uniqueId() });
      });
  });

  // 自定义标签新增全部tag
  customTags.forEach(firstFilter => {
    const { tags } = firstFilter;
    Array.isArray(tags) &&
      tags.length > 0 &&
      tags.unshift({ name: '全部', tagId: 'ALL' });
  });
  return { systemTags, customTags };
}

// 设置提交的筛选条件组合
export function setSubmitFilters(filters) {
  return {
    type: ACTIONS.SET_SUBMIT_FILTERS,
    filters,
  };
}

// 清空筛选条件组合
export function clearSubmitFilters() {
  return { type: ACTIONS.CLEAR_SUBMIT_FILTERS };
}

//清空单个过滤条件
export function clearSingleSubmitFilters(key) {
  return { type: ACTIONS.CLEAR_SINGLE_FILTER, key };
}
